import axios from "../../../../../../api/axiosInstance";
import { FetchMemberDashboardResponse } from "./types";

export const fetchMemberDashboard = async (
  signal?: AbortSignal,
): Promise<FetchMemberDashboardResponse> => {
  const response = await axios.get<FetchMemberDashboardResponse>(
    "/api/private/member-dashboard",
    { signal },
  );
  return response.data;
};
